var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-bg",
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-bell",
    d: "M16.3164 13.3997L15.1247 12.208C13.1247 13.733 11.8081 16.083 11.6914 18.7497H13.3581C13.4831 16.5413 14.6164 14.608 16.3164 13.3997ZM26.6414 18.7497H28.3081C28.1831 16.083 26.8664 13.733 24.8747 12.208L23.6914 13.3997C25.3747 14.608 26.5164 16.5413 26.6414 18.7497ZM24.9997 19.1663C24.9997 16.608 23.6331 14.4663 21.2497 13.8997V13.333C21.2497 12.6413 20.6914 12.083 19.9997 12.083C19.3081 12.083 18.7497 12.6413 18.7497 13.333V13.8997C16.3581 14.4663 14.9997 16.5997 14.9997 19.1663V23.333L13.3331 24.9997V25.833H26.6664V24.9997L24.9997 23.333V19.1663ZM19.9997 28.333C20.1164 28.333 20.2247 28.3247 20.3331 28.2997C20.8747 28.183 21.3164 27.8163 21.5331 27.3163C21.6164 27.1163 21.6581 26.8997 21.6581 26.6663H18.3247C18.3331 27.583 19.0747 28.333 19.9997 28.333Z",
    fill: "#41464B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon-notifications.67c383609527580a0c8f3dc20a08dea4.svg";
export { ForwardRef as ReactComponent };